import { ReactNode } from 'react';
import { ProductList } from '@/models/ProductList';
import ProductListDetailNav from '@/modules/product/components/ProductListDetailNav';
import SettingsHeader from '@/modules/settings/components/SettingsHeader';
import { RectangleStackIcon } from '@heroicons/react/24/outline';

interface ProductListDetailHeaderProps {
  productList: ProductList;
  children?: ReactNode;
}

const ProductListDetailHeader = ({ productList, children }: ProductListDetailHeaderProps) => (
  <>
    <SettingsHeader title={productList.name} icon={<RectangleStackIcon className="h-6 w-6" />}>
      {children}
    </SettingsHeader>

    <ProductListDetailNav productListId={productList.id} />
  </>
);

export default ProductListDetailHeader;
